<template>
	
  <div @click="openDialog" :class="['p-grid', 'p-ai-center', {'gray': !(canSanigenBeEdited && !role.includes('INTERNAL')) }, {'clickable': canSanigenBeEdited && !role.includes('INTERNAL')}]">
    <div :class="['p-col-fixed p-text-center',{'data-grid-parameter-icon':size==='small'}]">
      <!-- <span class="icon-sanigen_new" :style="{fontSize: size==='small' ? '25px' : '35px'}" :class="[{'gray': !(canSanigenBeEdited && !role.includes('INTERNAL'))}]" /> -->
      <img src="assets/irinox/icons/sanigen_param_new.svg" :width="size==='small' ? 30 : 40" :class="[{'filter-gray': !(canSanigenBeEdited && !role.includes('INTERNAL'))}]" alt="Sanigen" :style="{opacity: !(canSanigenBeEdited && !role.includes('INTERNAL')) ? 0.8 : 1}"/>
    </div>
    <div :class="['p-col',{'data-grid-parameter-text':size==='small'}]">
      <span>{{$t('details.info_sanigen')}}</span>
    </div>
    <div :class="['p-col-fixed p-text-right',{'data-grid-parameter-value':size==='small'}]">
      {{originalSanigenLevel!=null ? rebasedSanigenLevel+'/5' : '-'}}
    </div>
    <div :class="['param-cta',{'data-grid-parameter-cta':size==='small'}]">
      <i v-if="canSanigenBeEdited && !role.includes('INTERNAL')" class="pi pi-chevron-right" />
    </div>
  </div>

  <!--                    -->
  <!-- ERRORS and SUCCESS -->
  <!--                    -->
  <IrinoxDialogDark :visible="dialog.error" 
    mode="error" 
    :message="$t('details.delete_error')"
    :life="3000" 
    @update:visible="dialog.error = $event" />
  <IrinoxDialogDark :visible="dialog.blockingError" 
    mode="error" 
    :message="$t('details.delete_error')"
    :life="0" 
    @update:visible="dialog.blockingError = $event" />

  <Dialog v-model:visible="dialog.sanigen" class="irinox-dialog-dark" :modal="true" 
      :closable="true" :dismissableMask="true" :draggable="false">
    
    <div class="irinox-dialog-dark-content">
      <div class="p-mb-3">{{$t('details.info_sanigen_ph')}}</div>
      <div v-for="sl in sanigenLevels" class="p-text-center" :key="sl.code">
        <Button :label="sl.name" @click="saveSanigen(sl.code)"  :class="[{'p-button-secondary':sl.code===originalSanigenLevel}]"  />
      </div>
    </div>

    <template #footer>
    </template>
  </Dialog>

</template>

<script>
import { mapGetters } from 'vuex';
import IrinoxDialogDark from '../IrinoxDialogDark.vue';
import ApplianceService from '../../service/ApplianceService';
import EventHubListenerService from '../../service/EventHubListenerService';

export default {
    components: {
      IrinoxDialogDark,
    },
    props: {
      serialNumber: String,
      size: String,
    },
    data() {
        return {
          dialog: {
            delete: false,
            error: false,
            blockingError: false,
            deleteSuccess: false,
            sanigen: false,
          },
          sanigenLevels: []
        };
    },
    computed: {
        ...mapGetters({
          personaltoken: 'userdata/personaltoken',
          unit: 'userdata/unit',
          deviceTwin: 'appliances/deviceTwin',
          role: 'userdata/role',
        }),
        appliance: function() {
            return this.$store.getters['appliances/appliance'](this.serialNumber);
        },
        infoSanigenLevel: function() {
          return this.deviceTwin && this.deviceTwin.status && this.appliance && this.appliance.gamma ? this.$t('details.'+this.getGammaLabel(this.appliance.gamma)+'.sanigen_level_'+this.deviceTwin.status.sanigenLevel) : "-";
        },
        originalSanigenLevel: function() {
          if(this.deviceTwin && this.deviceTwin.status && this.appliance && this.appliance.gamma) {
            return this.deviceTwin.status.sanigenLevel;
          }
          return null;
        },
        rebasedSanigenLevel: function() {
          if(this.originalSanigenLevel != null && this.appliance.gamma === 'MYA') {
            let tmpSL = this.originalSanigenLevel+1;
            if(tmpSL>5) {
              tmpSL = 0;
            }
            return tmpSL;
          }
          return this.originalSanigenLevel;
        },
        canSanigenBeEdited: function() {
          return this.appliance && this.appliance.online==true;
        }
    },
    watch: {
    },
    created() {
      this.applianceService = new ApplianceService();
      this.eventHubListenerService = new EventHubListenerService();

      let start = 0;
      let end = 5;
      if(this.appliance.gamma==='MYA') {
        start = -1;
        end = 4;
      }
      if(this.appliance.type=='ABBATTITORE' || this.appliance.type=='FERMALIEVITA') {
        for(let i=start; i<=end; i++) {
          this.sanigenLevels.push({
              code: this.getSanigenLevel(i),
              name: this.$t("details."+this.getGammaLabel(this.appliance.gamma)+"['sanigen_level_"+this.getSanigenLevel(i)+"']")
            });
        }
      }
    },
    mounted() {
    },
    methods: {
      getGammaLabel(gamma) {
        return gamma.split(" ")[0].toLowerCase();
      },
      getSanigenLevel(i) {
        if(i<0) {
          return 65536+i;
        }
        return i;
      },
      openDialog() {
        if(this.canSanigenBeEdited && !this.role.includes('INTERNAL')) {
          this.dialog.sanigen = true;
        }
      },
      saveSanigen(sanLvl) {
        let updateData = {
          sanigenLevel: sanLvl
        }
        this.dialog.sanigen = false;
        this.eventHubListenerService.postSetParameter(this.personaltoken, this.serialNumber, updateData)
          .then((data) => {
            if(data.code=="200") {
              let dt = this.$functions.clone(this.deviceTwin);
              dt.status.sanigenLevel = sanLvl;
              this.$store.commit('appliances/deviceTwin', dt);
            } else {
              console.error("ERROR "+JSON.stringify(data));
              this.dialog.error = true;
            }
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.dialog.error = true;
          });
      }
    }
}
</script>

<style scoped>

.p-fluid .p-inputtext {
  width: 70%;
}
.p-fluid .p-dropdown {
  width: 70%;
}

</style>